import { axios } from '../../services/axios';

const getWebexServiceProfileRegions = ({ scope }) => {
    return axios.get(
        `/ServiceProfiles/Webex/${scope}/CountriesLists/Available`,
    );
};
export default getWebexServiceProfileRegions;
